import React from 'react'
import { Container, Button } from 'react-bootstrap';
import "./Sports_event.css";
import Send_message from '../../common-components/common-btn/send_message/Send_message';
import { useNavigate } from 'react-router-dom';

const Sports_event = () => {

      const navigate = useNavigate()

    return (
        <section className='sports-section'>
            <div className="sports-event-section">
                <Container className="text-center content"> 
                    <div className='section-title'>
                        <h1 className="title">
                            Professional Sports <br />
                            <span className="highlight">Event Management</span>
                        </h1>
                    </div>

                    <p className="subtitle">
                        From School meets to Corporate tournaments and Marathons –
                        We organize sports events that inspire and engage.
                    </p>
                    <div className='button'>
                        <Send_message text='Get Enquiry' onClick={() => {navigate("/contact-us")}}/>
                    </div>
                </Container>
            </div>
        </section>
    )
}

export default Sports_event